<a class="nav-link" matRipple>
  @if (item.icon) {
    <mat-icon class="nav-link-icon">{{item.icon}}</mat-icon>
  }
  <span class="nav-link-title">{{item.title}}</span>
  <mat-icon class="collapse-arrow">keyboard_arrow_right</mat-icon>
</a>

<div class="children" [ngClass]="{'open': isOpen}">

  <div class="{{fuseSettings.colorClasses.navbar}}">

    @for (item of item.children; track item) {
      @if (item.type=='item') {
        <fuse-nav-horizontal-item [item]="item"></fuse-nav-horizontal-item>
      }
      @if (item.type=='collapse') {
        <fuse-nav-horizontal-collapse [item]="item"></fuse-nav-horizontal-collapse>
      }
      @if (item.type=='group') {
        <fuse-nav-horizontal-collapse [item]="item"></fuse-nav-horizontal-collapse>
      }
    }

  </div>

</div>